export default __webpack_public_path__ + "static/media/american-express.92e7bcad.png";